/**
 * Singleton PocketBase JS SDK — source de vérité unique pour tous les appels API.
 *
 * Import : import { pb } from '@/lib/pb';
 *
 * - Gestion du token d'auth entièrement déléguée à pb.authStore (localStorage "pb_auth")
 * - `pb.autoCancellation(false)` : évite les annulations intempestives en React StrictMode
 */

import PocketBase from "pocketbase";

// ─── URL de base ──────────────────────────────────────────────────

function resolvePbUrl(): string {
  if (typeof window === "undefined") return "http://localhost:8095";

  const configured = (import.meta.env.VITE_PB_URL ?? "").trim();
  if (configured) return configured.replace(/\/$/, "");

  const { protocol, hostname, port } = window.location;
  const isLoopback = ["127.0.0.1", "localhost", "::1"].includes(hostname);

  if (isLoopback && ["5173", "5174"].includes(port)) {
    // Dev local : Vite dev server → PocketBase :8095 directement
    return `${protocol}//${hostname}:8095`;
  }

  // Prod / réseau : même origine, nginx proxifie /api/ et /_ vers PocketBase
  return `${protocol}//${hostname}${port ? `:${port}` : ""}`;
}

export const pb = new PocketBase(resolvePbUrl());

// Désactive l'auto-cancel : une requête en vol n'est pas annulée si le composant
// se re-rend (React StrictMode, TanStack Query refetch…)
pb.autoCancellation(false);
